<template>
  <MainLayout
    :bodyStyle="getBodyStyle"
  >
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-sm-6">
          <h5 class="sub-header-header typography--headline typography--color-secondary pl-10-mobile pr-10-mobile">
            AI 데일리 퀴즈
          </h5>
        </div>
        <div class="col-sm-6 hidden-xs-down">
          <div class="sub-header-btn-row float-right">
            <button
              class="btn btn-primary new-quiz-button"
              @click="handleNewQuizClick"
              :disabled="isLoadingMyQuizzes"
            >
              AI 데일리 퀴즈 만들기
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960 my-quizzes-wrapper" slot="layout-body">
      <LoadingBounce class="loading" v-if="isLoadingMyQuizzes && isEmptyQuizzes" />
      <div v-else class="row">
        <div class="no-quiz-wrapper" v-if="isEmptyQuizzes">
          지금 바로 AI 데일리 퀴즈를 만들어 보세요.
        </div>
        <div v-else class="col-lg-6 col-xs-12 quiz-wrapper" v-for="(quiz, index) in myQuizzes" :key="index">
          <MyQuizCard :quiz="quiz" @click="handleQuizClick(quiz)"/>
        </div>
        <InfiniteLoading
          v-if="isInfiniteLoading"
          class="w-100"
          :on-infinite="onInfiniteMyQuizzes"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <LoadingBounce class="loading" />
          </div>
          <span slot="no-results" />
          <span slot="no-more" />
        </InfiniteLoading>
      </div>
      <QuizFormModal
        v-if="isQuizFormModal"
        :quiz="quiz"
        @cancel="handleModalCloseClick"
      />
      <MyQuizModal
        v-if="isQuizModal"
        :quiz="quiz"
        @ok="handleQuizModalOkClick"
        @cancel="handleQuizModalCancelClick"
      />
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, floor } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';

  import types from '../store/mutation-types';
  import QuizFormModal from '../components/QuizFormModal';
  import MyQuizCard from '../components/MyQuizCard';
  import MyQuizModal from '../components/MyQuizModal';
  import { PER_PAGE } from '../../../constants';

  export default {
    name: 'my-quizzes',

    data() {
      return {
        isQuizFormModal: false,
        isQuizModal: false,
        quiz: {},
      };
    },

    components: {
      QuizFormModal,
      MyQuizCard,
      InfiniteLoading,
      MyQuizModal,
    },

    computed: {
      ...mapGetters({
        myQuizzes: 'getMyQuizzes',
        isLoadingMyQuizzes: 'isLoadingMyQuizzes',
        totalMyQuizzes: 'getTotalMyQuizzes',
      }),

      isEmptyQuizzes() {
        return isEmpty(this.myQuizzes);
      },

      isInfiniteLoading() {
        return this.myQuizzes.length < this.totalMyQuizzes;
      },

      getBodyStyle() {
        return {
          background: 'linear-gradient(to bottom, #4823ae, #9751c7 64%)',
          'min-height': '100vh',
        };
      },
    },

    methods: {
      ...mapActions([
        'fetchMyQuizzes',
      ]),

      handleNewQuizClick() {
        this.quiz = {};
        this.isQuizFormModal = true;
      },

      handleModalCloseClick() {
        this.isQuizFormModal = false;
      },

      handleQuizClick(quiz) {
        this.quiz = quiz;
        this.isQuizModal = true;
      },

      handleQuizModalCancelClick() {
        this.isQuizModal = false;
      },

      handleQuizModalOkClick() {
        this.isQuizModal = false;
        this.isQuizFormModal = true;
      },

      async onInfiniteMyQuizzes() {
        const page = floor(this.myQuizzes.length / PER_PAGE) + 1 || 1;
        const params = {
          page,
          per_page: PER_PAGE,
          sort: '-created_at',
        };

        await this.fetchMyQuizzes({ type: types.FETCH_INFINITE_MY_QUIZZES_SUCCESS, params });

        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
          if (this.myQuizzes.length === this.totalMyQuizzes) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          }
        }
      },
    },

    beforeMount() {
      const params = {
        page: 1,
        per_page: PER_PAGE,
        sort: '-created_at',
      };

      this.fetchMyQuizzes({ type: types.FETCH_MY_QUIZZES_SUCCESS, params });
    },
  };
</script>

<style lang="scss" scoped>
  .new-quiz-button {
    background-image: linear-gradient(103deg, #3023ae, #c86dd7 102%);
  }

  .my-quizzes-wrapper {
    padding: 0 0 20px 0;

    .loading {
      padding: 40px;
    }

    .quiz-wrapper {
      padding: 10px;
    }

    .no-quiz-wrapper {
      color: #ffffff;
      padding: 25%;
      margin: 0 auto;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/my-quizzes/views/MyQuizzes.vue